


import React from 'react'

export const ArrowLeft = () => {
  return (
        
            <svg width="25px" height="25px"  viewBox="0 0 512.013 512.013" style={{transition: ".1s" ,cursor: "pointer"}}>
                <g>
                    <path d="M366.64,256.013L508.677,32.802c5.141-8.107,4.267-18.624-2.176-25.749c-6.443-7.168-16.832-9.067-25.365-4.8
                        L11.802,236.92c-7.232,3.627-11.797,11.008-11.797,19.093c0,8.085,4.565,15.467,11.797,19.093l469.333,234.667
                        c3.029,1.515,6.293,2.24,9.536,2.24c5.888,0,11.691-2.432,15.829-7.04c6.443-7.125,7.317-17.643,2.176-25.749L366.64,256.013z"/>
                </g>
            </svg>
    
  )
}
